(() => {
  if (customElements.get('track-order')) return;

  let widgetPromise;
  function loadWidget() {
    if (window.YQV5) return Promise.resolve(window.YQV5);
    if (widgetPromise) return widgetPromise;
    widgetPromise = new Promise((resolve, reject) => {
      const script = document.createElement('script');
      const timeout = setTimeout(() => finish(new Error('Widget timed out')), 15000);
      function finish(error) {
        clearTimeout(timeout);
        script.onload = script.onerror = null;
        if (error) {
          script.remove();
          reject(error);
        } else resolve(window.YQV5);
      }
      script.src = 'https://www.17track.net/externalcall.js';
      script.async = true;
      script.onload = () => finish(window.YQV5 ? null : new Error('Widget unavailable'));
      script.onerror = () => finish(new Error('Widget unavailable'));
      document.head.appendChild(script);
    }).catch((error) => {
      widgetPromise = null;
      throw error;
    });
    return widgetPromise;
  }

  customElements.define('track-order', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.querySelector('form').addEventListener('submit', (event) => this.track(event));
    }

    disconnectedCallback() {
      clearTimeout(this.resultTimeout);
    }

    async track(event) {
      event.preventDefault();
      if (this.busy) return;
      const input = this.querySelector('input');
      const number = input.value.trim();
      if (!number || !input.reportValidity()) return;
      const button = this.querySelector('button');
      const status = this.querySelector('[data-status]');
      const results = this.querySelector('[data-results]');
      const container = this.querySelector('[data-widget]');
      this.querySelector('[data-fallback]').href = `https://t.17track.net/en#nums=${encodeURIComponent(number)}`;
      clearTimeout(this.resultTimeout);
      this.busy = true;
      button.disabled = true;
      status.textContent = this.dataset.loading;
      results.hidden = true;
      container.replaceChildren();
      try {
        const widget = await loadWidget();
        if (!this.isConnected) return;
        results.hidden = false;
        widget.trackSingle({
          YQ_ContainerId: container.id,
          YQ_Height: 560,
          YQ_Fc: '0',
          YQ_Lang: 'en',
          YQ_Num: number
        });
        const frame = container.querySelector('iframe');
        if (!frame) throw new Error('Missing tracking frame');
        frame.title = this.querySelector('h2').textContent.trim();
        frame.addEventListener('load', () => {
          clearTimeout(this.resultTimeout);
          status.textContent = this.dataset.ready;
        }, { once: true });
        this.resultTimeout = setTimeout(() => {
          status.textContent = this.dataset.error;
        }, 20000);
      } catch (error) {
        status.textContent = this.dataset.error;
      } finally {
        this.busy = false;
        button.disabled = false;
      }
    }
  });
})();
